import { Link } from 'react-router-dom';
import { menuCategories } from '@/mocks/menuItems';

export default function MenuPreview() {
  const featuredItems = menuCategories
    .flatMap((cat) => cat.items)
    .filter((item) => item.badge)
    .slice(0, 4);

  const otherItems = menuCategories
    .flatMap((cat) => cat.items)
    .filter((item) => !item.badge)
    .slice(0, 4);

  const displayItems = [...featuredItems, ...otherItems].slice(0, 6);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
            Dine With Us
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            Our Tea Menu
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base">
            From traditional Karak chai to specialty blends, every cup is brewed
            fresh with love and the finest ingredients.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {displayItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 hover:shadow-sm"
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.name}
                </h3>
                <span className="font-label text-primary-600 font-semibold text-sm whitespace-nowrap ml-3">
                  {item.price}
                </span>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                {item.description}
              </p>
              {item.badge && (
                <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full">
                  {item.badge}
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12">
          <Link
            to="/menu"
            className="inline-flex items-center gap-2 px-6 py-3 border border-primary-500 text-primary-600 text-sm font-medium rounded-md hover:bg-primary-500 hover:text-background-50 transition-all"
          >
            View Full Menu
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}